
import { Button } from '@/components/ui/button';

interface HeroBlockProps {
  content: {
    headline: string;
    subheadline: string;
    backgroundImageUrl: string;
    ctaButtonText: string;
    ctaButtonLink: string;
  };
}

export const HeroBlock = ({ content }: HeroBlockProps) => {
  const { headline, subheadline, backgroundImageUrl, ctaButtonText, ctaButtonLink } = content;

  return (
    <section 
      className="relative min-h-[500px] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{ 
        backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        {headline && (
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            {headline}
          </h1>
        )}
        {subheadline && (
          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-2xl mx-auto">
            {subheadline}
          </p>
        )}
        {ctaButtonText && ctaButtonLink && (
          <Button 
            asChild
            size="lg" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg"
          >
            <a href={ctaButtonLink}>{ctaButtonText}</a>
          </Button>
        )}
      </div>
    </section>
  );
};
